export const CabinetConfigurationSettingNameConstants = {
  InputType: 'InputType',
  ValidationType: 'ValidationType',
  MatchingRecordAction: 'MatchingRecordAction',
  Description: 'Description',
  ClearReferencesAfterUpdate: 'ClearReferencesAfterUpdate'
};